<script>
    export default {
        data() {
            return {
                tagName: '',
            }
        },
        props: {
            tagID: Number,
            tagColor: String,
        },
        methods: {
            async updateTagName() {
                let tagValue = await this.$store.getters.TAGS_BY_ID(this.tagID);
                if (tagValue != null) {
                    this.tagName = tagValue.name;
                }
            }
        },
        async mounted() {
            await this.updateTagName();
        },
        watch: {
            tagID: { handler: async function() { 
                await this.updateTagName();
            }}
        },
        emits: ['deleteTag']

    }
</script>


<template>
    <div :style="`background-color: var(--${tagColor});`">
        <label>{{ tagName }}</label>
        <button @click="$emit('deleteTag', tagID)">X</button>
    </div>
</template>


<style scoped>
    div {
        border-radius: 5px;
        padding: 5px;
        margin-right: 5px;
        border: var(--border);
    }
    div > label {
        color: var(--tag-text);
    }
    
    button {
        margin-left: 5px;
        cursor: pointer;
        background: transparent;
        border: none;
        border-left: 2px solid var(--tag-text);
        color: var(--tag-text);
    }
</style>